<template>
    <template v-if="index === 0 || index === 5">
        <li class="col-12 big">
            <a :href="getLinkUrl(item)" class="p-0" :class="item.Link.Url === '#nolink' ? 'pe-none' : ''" :target="target(item)" @click="goTo($event, item)">
                <img :src="item.Img.Src" class="heroImg absolute" :alt="item.Link.Text">
                <img src="@/assets/new/hero-new.png" class="d-block" alt="bg">
            </a>
        </li>
    </template>
    <template v-else>
        <li class="col-6">
            <a :href="getLinkUrl(item)" class="" :class="item.Link.Url === '#nolink' ? 'pe-none' : ''" :target="target(item)" @click="goTo($event, item)">
                <div class="hotline">{{ item.Link.Text2 }}</div>
                <div class="box">
                    <div class="pic">
                        <img :src="item.Img.Src" class="d-block" :alt="item.Link.Text">
                    </div>
                    <div class="content">
                        <div class="pd_title">{{ item.Link.Text }}</div>
                        <div class="price">
                            <small>{{ item.Link.Text3 === '' ? '' : '$' + item.Link.Text3 }}</small>
                            <strong><i>$</i>{{ item.Link.Text1 }}</strong>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </template>

</template>

<script>
import { linkMixin } from '../mixin.js';

export default {
    name: 'brandPDTemplate',
	mixins: [linkMixin],
	props: ['item', 'index'],
};
</script>

<style lang="scss" scoped>
$brandColor:#008bec;
.brandPD {
    li {
        padding: 0 .4rem;
        margin-bottom: .8rem;
        @media only screen and (max-width: 640px) {
            padding: 0 5px;
            margin-bottom: .8rem;
        }
        &.big {
            a {
                // border: 2px solid #303321;
                position: relative;
                display: block;
                border-radius: 1rem;
                overflow: hidden;
                img {
                    border-radius: 1rem;
                    transition: .3s;
                    z-index: 1;
                }
                img.heroImg {
                    transform: translate(-50%, 0) !important;
                    width: auto;
                    height: 100%;
                    pointer-events: none;
                }
                &:hover img.heroImg {
                    transform: translate(-50%, 0) !important;
                    filter: brightness(1.1);
                    @media only screen and (max-width: 991px) {
                        filter: none;
                    }
                }
                .note {
                    display: block;
                    position: absolute;
                    top: .6rem;
                    right: 0;
                    color: #ce0238;
                    font-weight: 500;
                    background-color: #fff;
                    padding: 0 .6rem;
                    z-index: 1;
                    border-radius: 10rem 0 0 10rem;
                }
            }
        }
    }
    a {
        display: block;
        height: 100%;
        position: relative;
        text-decoration: none;
        transition: .3s all;
    }
    .box {
        display: flex;
        background-color: #fff;
        padding: 8px 7px;
        position: relative;
        border-radius: 0 0 1rem 1rem;
        -webkit-mask: -webkit-radial-gradient(circle, white 100%, black 100%);
        @media only screen and (max-width: 1024px) {
            padding: 5px 4px;
        }
        @media only screen and (max-width: 640px) {
            flex-wrap: wrap;
        }
    }
    .pic {
        width: 48%;
        padding: 0;
        overflow: hidden;
        @media only screen and (max-width: 640px) {
            width: 100%;
            order: 1;
        }
    }
    .content {
        width: 52%;
        padding: 8px 0 0 8px;
        position: relative;
        @media only screen and (max-width: 640px) {
            width: 100%;
            padding: 0;
            margin-top: 5px;
            order: 3;
        }
    }
    .hotline {
        position: relative;
        color: #fff;
        font-size: 1.1rem;
        font-weight: 500;
        line-height: 1.5;
        text-align: center;
        padding: 4px 0;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        background: #fa5369;
        border-radius: 1rem 1rem 0 0;
        -webkit-mask: -webkit-radial-gradient(circle, white 100%, black 100%);
        @media only screen and (max-width: 797px) {
            font-size: 3.8vw;
        }
    }
    .pd_title {
        line-height: 1.3;
        font-size: 1rem;
        font-weight: 500;
        color: #000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        @media only screen and (max-width: 767px) {
            font-size: 3.5vw;
            height: 9.9vw;
            line-height: 1.4;
            margin-bottom: 5px;
        }
        /* @media only screen and (max-width: 350px) {
            font-size: 13px;
            height: 38px;
        } */
    }
    .price {
        width: 100%;
        font-family: Montserrat, "Noto Sans TC";
        position: absolute;
        bottom: 5px;
        @media only screen and (max-width: 640px) {
            position: static;
            display: flex;
            justify-content: center;
            align-items: baseline;
            line-height: 1;
        }
        strong {
            font-size: 1.6rem;
            font-weight: 700;
            color: #f01b34;
            display: block;
            line-height: 1;
            @media only screen and (max-width: 991px) {
                font-size: 1.4rem;
            }
            @media only screen and (max-width: 767px) {
                font-size: 6vw;
            }
            i {
                font-weight: 500;
                font-size: 60%;
            }
        }
        small {
            display: block;
            line-height: 1;
            font-size: 80%;
            text-decoration: line-through;
            color: #8e8e8e;
            @media only screen and (max-width: 991px) {
                line-height: inherit;
                margin-right: 3px;
                font-size: 12px;
            }
            @media only screen and (max-width: 640px) {
                font-size: 11px;
            }
        }
    }
    a:hover {
        transform: scale(1.03);
        @media only screen and (max-width: 991px) {
            filter: none;
            transform: none;
        }
        img {
            filter: brightness(1.15);
            @media only screen and (max-width: 991px) {
                filter: none;
                transform: none;
            }
        }
    }
}
</style>
